import TextFieldComponent from '../textfield';

class PasswordComponent extends TextFieldComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default PasswordComponent;
